import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {checkIfFeatureDisabled} from "../../lookFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {getFeatureSectionIsHidden, getFeatureUrl} from "../../lookFunctions2";
import {setLookActiveFeature} from "../../../../../actions/lookFunctions";
import LookMobileInfoButtonAnimatedIcon from "../../../animations/lookMobileInfoButtonAnimatedIcon";
import {setWizardShowFeatureSection} from "../../../../../actions/wizardFunctions";

const LookListActiveFeatureMobileButton = (props) => {

  const {lookFeature, setLookActiveFeature, history, isActive, lookLockedTutorial, isWizard,
    setWizardShowFeatureSection} = props;

  if (!isActive || lookLockedTutorial.visible) {
    return null
  }

  if (!isWizard) {
    const featureSectionIsHidden = getFeatureSectionIsHidden(lookFeature);
    if (featureSectionIsHidden) {
      return null
    }

    const parent = lookFeature.getParent();
    const alreadyDisabled = checkIfFeatureDisabled(lookFeature, parent, true);

    if (alreadyDisabled) {
      return null
    }
  }

  const infoButtonClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMobileActiveFeatureButton);

    if (isWizard) {
      setWizardShowFeatureSection(true);
      return
    }

    setLookActiveFeature(lookFeature);
    history.push(getFeatureUrl(lookFeature, true));
  }

  return (
    <div onClick={infoButtonClick} className="lm-feature__info-animation">
      <LookMobileInfoButtonAnimatedIcon />
    </div>
  )
};

LookListActiveFeatureMobileButton.propTypes = {
  lookFeature: PropTypes.shape(featureInterface).isRequired,
  isActive: PropTypes.bool.isRequired,
  isWizard: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {canvasCount} = store.bathroomVisualizerState;
  const {lookLockedTutorial} = store.lookState;

  return {
    canvasCount,
    lookLockedTutorial,
  };
};

const mapDispatchToProps = {
  setLookActiveFeature,
  setWizardShowFeatureSection,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookListActiveFeatureMobileButton)
  )
)
